import { render, staticRenderFns } from "./CreateGeneralPopup.vue?vue&type=template&id=5c1ac86f"
import script from "./CreateGeneralPopup.vue?vue&type=script&lang=js"
export * from "./CreateGeneralPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports